export default "__VITE_ASSET__a38b998f__"